
define([], function() {
  var RangeStorage, notImplemented;
  notImplemented = function() {
    throw new Error('Not Implemented');
  };
  return RangeStorage = (function() {

    function RangeStorage() {}

    RangeStorage.prototype.getEarliestDate = function() {
      return notImplemented();
    };

    RangeStorage.prototype.saveInterval = function(interval) {
      return notImplemented();
    };

    RangeStorage.prototype.loadInterval = function() {
      return notImplemented();
    };

    return RangeStorage;

  })();
});
